var _path, _path2, _path3, _path4, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLife(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8985 8.69486C16.4411 8.47045 16.0492 8.13303 15.7592 7.71901L12.0267 12.1254L7.83644 7.17859H15.4586C15.3039 6.81678 15.2182 6.41839 15.2182 6C15.2182 5.89142 15.224 5.78419 15.2352 5.67859H6.21822H4.60001L5.64594 6.91335L11.4545 13.7705L12.0267 14.4461L12.599 13.7705L16.8985 8.69486Z",
    fill: "#020617"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1384 13.2858V21.0001",
    stroke: "#020617",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.73398 21H15.5425",
    stroke: "#020617",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9 6L5.90426 3H2.5",
    stroke: "#020617",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 6,
    r: 3,
    stroke: "#020617",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLife);
export default __webpack_public_path__ + "static/media/icon-life.93627ebe1ca1720c3d5e203d580dee30.svg";
export { ForwardRef as ReactComponent };